module.exports = __webpack_public_path__ + "static/media/023.2c70be1c.jpg";